<template>
  <div class="mw-panel">
     <el-col :span="8">
        <div class="mw-toolbar">
          <el-button  @click="newCatalog" size="mini" type="primary"><i class="fa fa-plus-square" ></i> 新建分类</el-button>
        </div>
        <div class="mw-toolbar__body">
           <mw-tree :multiple="false" :types="types"
                 :expandedFirst="true" :treeData="treeData" :autoLoad="false"
                 :contextMenuItem="menuItem"
                 ref="codeTree" @changed="changed" >
          </mw-tree>
        </div>
      </el-col>

      <el-col :span="16" >
        <div class="mw-toolbar">
          <el-col :span="6" >
          <el-button size="mini" type="primary" @click="addValues"><i class=" fa fa-plus-square"></i> 添加</el-button>
          </el-col>

          </div>
        <div class="mw-toolbar__body,setting">

           <el-table :data="settingValues" empty-text="">
             <el-table-column label="名称" prop="name">
                 <template slot-scope="scope">
                   <a @click="editSetValue(scope.row,scope.$index)">{{scope.row.name}}</a>
                  </template>
             </el-table-column>
             <el-table-column  label="编号"     width="155">
                   <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                      <p>{{ scope.row.id }}</p>
                      <div slot="reference" class="name-wrapper">
                        <span >{{ scope.row.id }}</span>
                      </div>
                    </el-popover>
                  </template>
             </el-table-column>
             <el-table-column  label="" width="100">
               <template slot-scope="scope">
                 <el-button @click="handleDelete(scope.row,scope.$index)" type="danger" icon="el-icon-delete" circle></el-button>
               </template>
             </el-table-column>
           </el-table>
        </div>
      </el-col>

      <mw-dialog ref="valueKeyDialog" :footerButton="valueBtns" size="mini_mini">
      <div class="mw-toolbar_body" style="margin-top:20px">
      <el-form label-width="60px">
        <el-form-item prop="name" label="名称">
          <el-input v-model="keyValues.name"></el-input>
        </el-form-item>
        <el-form-item prop="id" label="编号">
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 8}"
            placeholder="请输入内容"
            v-model="keyValues.id">
          </el-input>
        </el-form-item>
      </el-form>
      </div>
    </mw-dialog>
  </div>
</template>
<script>
export default {
  props:{
    dataId: {
       type: String,
       default: ''
    }
  },
  data() {
    return {
      treeData: [],
      settingValues: [],
      menuItem:[{name: 'add', label: '新增', func: this.addCatalog},
       {
        name: 'edit',
        label: '修改',
        func: this.editCatalog
      },
      {
        name: 'delete',
        label: '删除',
        func: this.deleteCatalog
      }],
      valueBtns: [
        {
          label: "确定",func:this.addValueSure
        },
        {
         label: "取消",
         type: "default",
         func:this.closeValueDialog
        }
      ],
      types:{"#": {
          "icon": "fa fa-leaf"
        },
          "file": {
            "icon": "fa fa-leaf"
          },
          "default": {
            "icon": "fa fa-leaf"
          }},

      keyValues:{

      },

      editOrAdd: true,
      rowindex: 0
    }

  },

  mounted() {
    this.getTreeData();
  },

  methods: {
    queryTreeData(json,data){
      json.forEach(d=>{
       if(d.id == data.id){
         if(d.data && d.data.length >0){
          this.settingValues = d.data;}else{
          this.settingValues = []
         }
       }else{
         if(d.children && d.children.length > 0){
          this.queryTreeData(d.children,data)
         }
       }
     })
    },
    changed(data){
      this.selectCodeNode = data.id;
      this.queryTreeData(this.treeData,data);
    },

    //加载对话框左边的树的数据
    getTreeData() {
       this.treeData = [];
       if(this.dataId){
         let appId=this.$route.params.appId;
         this.mwApi.data.getDict(this.dataId, {applicationId:appId}).then(res => {
          if (res.result && res.result.codeContent) {
             this.treeData = JSON.parse(res.result.codeContent);
          }else{
            this.treeData = [];
          }
        });
       }
    },
    createRandomId() {
        return (Math.random()*10000000).toString(16).substr(0,4)+''+(new Date()).getTime()+''+Math.random().toString().substr(2,5);
    },
    newCatalog() {
      this.$prompt("请输入新分类的名字", "添加分类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          this.mwRef('codeTree').createNode('#',{id: 'x-node'+this.createRandomId(),
            name: value,
            text: value,
            type: 'file',
            },'last');
           this.treeData =  this.mwRef('codeTree').getTreeData();
        })
        .catch(() => {});
    },
    addCatalog(data,parentId,item,obj){
      let me = this;
      this.$prompt("请输入新分类的名字", "添加分类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
      .then(({ value }) => {
        // this.mwRef('codeTree').editNodeName(data);
        this.mwRef('codeTree').createNode(data,{id: 'x-node'+this.createRandomId(),
          name: value,
          text: value,
          type: 'file',
          },'last');
         this.mwRef('codeTree').refreshData(this.mwRef('codeTree').getTreeData());
        })
        .catch(() => {});

    },
    editCatalog(data,parentId,obj){
      this.mwRef('codeTree').editNodeName(data);
    },
    deleteCatalog(data,parentId,obj){
     this.mwRef('codeTree').deleteNode(data);
     this.treeData = this.mwRef('codeTree').getTreeData();
    },

    addValues(){
      if( !this.mwRef('codeTree').getSelected()){
        this.mwMsg('info','请选择分类')
      }else{
        this.mwRef('valueKeyDialog').show();
        this.keyValues ={};this.editOrAdd = false;
      }
    },

    queryTData(json,data){
      json.forEach(d=>{
       if(d.id === data){
         d.data = this.settingValues;
         return
       }else{
         if(d.children && d.children.length > 0){
             this.queryTData(d.children,data);
         }
       }
     });
     return json;
    },

    addValueSure(){
      this.closeValueDialog();
      if(this.editOrAdd){
        this.settingValues[this.rowindex].id = this.keyValues.id;
        this.settingValues[this.rowindex].name = this.keyValues.name;
      }else{
        this.settingValues.push(this.keyValues);
      }
      let treeData = this.mwRef('codeTree').getTreeData();
      this.treeData = this.queryTData(treeData,this.selectCodeNode);
    },
    closeValueDialog(){
      this.mwRef('valueKeyDialog').hide();
    },
    handleDelete(row,index){
      this.treeData =this.mwRef('codeTree').getTreeData();
      this.settingValues.splice(index,1);
      this.queryTData(this.treeData,this.selectCodeNode);
      this.mwRef('codeTree').refreshData(this.treeData);
    },
    editSetValue(row,index){
      this.mwRef('valueKeyDialog').show();
      let initValue = {
        id:row.id,
        name:row.name
      }
      this.keyValues =initValue;
      //this.keyValues.id = row.id;
      //this.keyValues.name =  row.name;
      this.editOrAdd = true;
      this.rowindex = index;
    },

    getValue(){
      let datas = this.mwRef('codeTree').getTreeData();
      function  changeJson(dataJson){
        dataJson.forEach( d =>{

          for(let t in d){
            if(t === 'id' || t==='text' || t==='data' || t==='children'){
               if(t === 'text'){
                 d.name = d.text;
                 delete d.text;
               }
            }else{
             delete d[t];
            }
          }

          if(d.children && d.children.length > 0){
             d.children =changeJson(d.children)
          }
        })
        return dataJson;
      }
      changeJson(datas);
      return datas;
    }


  },

  watch: {
    dataId: function(val) {
      this.getTreeData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/modules/index/views/appModule/dict/dataValues.vue